import { Checkbox, Grid, Box, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { AssuranceIcon } from 'images/index';
import { sanlamBlue } from 'Material-UI/colors';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';
import {
  StyledFormControlLabel,
  InlinedLongBody,
  StyledShortBody,
  StyledOrangeButton,
} from 'containers/PasswordRecoveryPages/PasswordRecoveryOptions/styles';
import messages from 'containers/PasswordRecoveryPages/PasswordRecoveryOptions/messages';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

export interface FormPropsType {
  intl: IntlShape;
  hashedEmail: string;
  hashedPhone: string;
  onSubmit: Function;
  showQuestionOption: boolean;
  showEmailOption: boolean;
  showPhoneOption: boolean;
  isLoading: boolean;
}
const Form = ({
  showEmailOption,
  showQuestionOption,
  showPhoneOption,
  isLoading,
  onSubmit,
  hashedEmail,
  hashedPhone,
  ...otherProps
}: FormPropsType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const [isEmailState, setIsEmailState] = useState(false);
  const [isPhoneState, setIsPhoneState] = useState(false);
  const [isQuestionState, setIsQuestionState] = useState(false);
  return (
    <form
      onSubmit={(event: React.SyntheticEvent) => {
        event.preventDefault();
        onSubmit({ isEmailState, isQuestionState, isPhoneState });
      }}
    >
      <Box paddingY={2} paddingX={[2, 4, 8]}>
        <Grid container justify="space-between" direction="column">
          {showEmailOption && (
            <Grid item xs>
              <StyledFormControlLabel
                control={
                  <Checkbox
                    checked={isEmailState}
                    name="email"
                    onClick={() => {
                      setIsEmailState(true);
                      setIsQuestionState(false);
                      setIsPhoneState(false);
                    }}
                    color="primary"
                    icon={
                      <img src={AssuranceIcon.checkedIcon} alt="checked-icon" />
                    }
                    checkedIcon={
                      <img
                        src={AssuranceIcon.unCheckedIcon}
                        alt="unchecked-icon"
                      />
                    }
                  />
                }
                label={
                  <Grid container direction="column">
                    <Grid item xs>
                      <Box>
                        <img src={AssuranceIcon.email} alt="email-icon" />
                        <InlinedLongBody
                          reverse={reverse}
                          weight="500"
                          color={sanlamBlue}
                        >
                          {translate(messages.email, otherProps)}
                        </InlinedLongBody>
                      </Box>
                    </Grid>
                    <Grid item xs>
                      <StyledShortBody weight="400">
                        {translate(messages.emailOption, otherProps)}{' '}
                        {hashedEmail}
                      </StyledShortBody>
                    </Grid>
                  </Grid>
                }
                checked={isEmailState}
              />
            </Grid>
          )}
          {showPhoneOption && (
            <Grid item xs>
              <StyledFormControlLabel
                control={
                  <Checkbox
                    checked={isPhoneState}
                    name="phone"
                    onClick={
                      /* istanbul ignore next */ () => {
                        setIsPhoneState(true);
                        setIsQuestionState(false);
                        setIsEmailState(false);
                      }
                    }
                    color="primary"
                    icon={
                      <img src={AssuranceIcon.checkedIcon} alt="checked-icon" />
                    }
                    checkedIcon={
                      <img
                        src={AssuranceIcon.unCheckedIcon}
                        alt="unchecked-icon"
                      />
                    }
                  />
                }
                label={
                  <Grid container direction="column">
                    <Grid item xs>
                      <Box>
                        <img src={AssuranceIcon.PhoneIcon} alt="phone-icon" />
                        <InlinedLongBody
                          reverse={reverse}
                          weight="500"
                          color={sanlamBlue}
                        >
                          {translate(messages.phone, otherProps)}
                        </InlinedLongBody>
                      </Box>
                    </Grid>
                    <Grid item xs>
                      <StyledShortBody weight="400">
                        {translate(messages.phoneOption, otherProps)}{' '}
                        {hashedPhone}
                      </StyledShortBody>
                    </Grid>
                  </Grid>
                }
                checked={isPhoneState}
              />
            </Grid>
          )}
          {showQuestionOption && (
            <Grid item xs>
              <StyledFormControlLabel
                control={
                  <Checkbox
                    checked={isQuestionState}
                    onClick={() => {
                      setIsEmailState(false);
                      setIsQuestionState(true);
                      setIsPhoneState(false);
                    }}
                    name="question"
                    color="primary"
                    icon={
                      <img src={AssuranceIcon.checkedIcon} alt="checked-icon" />
                    }
                    checkedIcon={
                      <img
                        src={AssuranceIcon.unCheckedIcon}
                        alt="unchecked-icon"
                      />
                    }
                  />
                }
                label={
                  <Grid container direction="column">
                    <Grid item xs>
                      <Box style={{ display: 'inline-block' }}>
                        <img src={AssuranceIcon.arrowUp} alt="arrowup-icon" />
                        <InlinedLongBody
                          reverse={reverse}
                          weight="500"
                          color={sanlamBlue}
                        >
                          {translate(messages.questionSecret, otherProps)}
                        </InlinedLongBody>
                      </Box>
                    </Grid>
                    <Grid item xs>
                      <StyledShortBody weight="400">
                        {translate(messages.questionSecretOption, otherProps)}
                      </StyledShortBody>
                    </Grid>
                  </Grid>
                }
                checked={isQuestionState}
              />
            </Grid>
          )}

          <Grid item xs>
            <StyledOrangeButton
              disabled={
                isEmailState || isQuestionState || isPhoneState ? false : true
              }
              type="submit"
              variant="contained"
            >
              {' '}
              {isLoading ? (
                <CircularProgress data-testid="loader" size={20} />
              ) : (
                <React.Fragment>
                  {translate(messages.chooseOption, otherProps)}
                </React.Fragment>
              )}
            </StyledOrangeButton>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default injectIntl(Form);
